module.exports = __webpack_public_path__ + "img/3-3.f6825dfb.png";